
var moment = require('moment')//for get time
import Vue from 'vue'
export default {
  parseActivityLogData: function (data) {
    // filter out 'upload' event
    if (data.action == 'upload' && data.trigger != 'Schedule') return {}
    return {
      logId: data.id,
      logType: data.desc_id ? Vue.actlog.getDescType(data.desc_id) : null, // Description Id로 logType 정의하기
      logMeta: data.meta,
      logInfo: {
        descriptionId: data.desc_id,
        description: data.description,
        trigger: data.trigger,    // Bridge | Schedule | OE trigger
        statusText: data.status_text,
        action: data.action,     // armed | disarmed | alarm | restoral | upload |
        category: data.category,
        email: data.email,
        aiThumbnail: data.detection_summary,
        thumbnail: data?.thumbnail_url,
      },
      deviceInfo: {
        deviceId: data.device_id,
        deviceName: data.name,
      },
      eventInfo: {
        eventId: data.event_id,
        eventCode: data.event_code, // contactID, xml signal
      },
      statusInfo: {
        createdDate: data.created ? new Date(data.created) : null,
        timestamp: data.event_timestamp
      }
    }
  },
  parseDeviceActivityLogData: function (data) {
    const ids =  Vue.actlog.deviceDescIds
    let type, summaryEntityNames, detectionSummary, aiType
    if (ids.alarmVideo.includes(data.desc_id)) type = 'alarm'
    else if (ids.disarmedVideo.includes(data.desc_id)) type = 'activity'
    
    if (data?.summary_entity_names) summaryEntityNames = JSON.parse(data.summary_entity_names)
    if (data?.detection_summary) detectionSummary = JSON.parse(data.detection_summary)
    
    
    // 0 - person & vehicle
    // 1 - person
    // 2 - vehicle
    // 3 - none
    if (detectionSummary?.person?.thumbnail && detectionSummary?.vehicle?.thumbnail) aiType = 0
    else if (detectionSummary?.person?.thumbnail) aiType = 1
    else if (detectionSummary?.vehicle?.thumbnail) aiType = 2
    else aiType = 3

      

    return {
      logId: data?.id,
      eventId: data?.event_id,
      descId: data?.desc_id,
      type: type,
      timestamp: data.event_timestamp ? data.event_timestamp : Math.floor(new Date(data?.created).getTime()/1000),
      summaryEntityNames,
      detectionSummary,
      aiType,
    }
  },
  parseActivityLogSearchData: function (data, timezone) {
    let info = data?._source || {}
    if (!info) return

    /////////////////////////////
    // id
    let id = data?._id
    info.id = id

    /////////////////////////////
    // id
    let sort = data?.sort
    info.sort = sort

    /////////////////////////////
    // type
    let type = Vue.actlog.getDescType(info?.item_id)
    info.type = type

    /////////////////////////////
    // trigger
    if (type === "scheduleArmed" || type === "scheduleDisarmed") info.trigger = "schedule"

    /////////////////////////////
    // time
    moment.locale(navigator.language)

    // 실제 로컬에서 이벤트가 발생한 시간
    if (info.event_time && timezone) {
      info.tsTimeStr = moment(info.event_time).tz(timezone).format('LTS') // e.g) 오전 7:28:14
      info.tsDateStr = moment(info.event_time).tz(timezone).format('LL') // e.g) 2023년 4월 11일
    }

    // 이벤트가 디비에 저장된 시간
    if (info.created_at && timezone) {
      info.cdTimeStr = moment(info.created_at).tz(timezone).format('LTS') // e.g) 오전 7:28:14
      info.cdDateStr = moment(info.created_at).tz(timezone).format('LL')  // e.g) 2023년 4월 11일
    }
    
    let backup = {
      logInfo: {
        descriptionId: info.desc_id,
        description: info.description,
        trigger: info.trigger,    // Bridge | Schedule | OE trigger
        statusText: info.status_text,
        action: info.action,     // armed | disarmed | alarm | restoral | upload |
        category: info.category,
        email: info.email,
        aiThumbnail: info.detection_summary,
        thumbnail: info?.thumbnail_url,
      },
      deviceInfo: {
        deviceId: info.device_id,
        deviceName: info.name,
      },
      eventInfo: {
        eventId: info.event_id,
        eventCode: info.event_code, // contactID, xml signal
        sourceEventTime: info.source_event_time
      },
      statusInfo: {
        createdDate: info.created ? new Date(info.created) : null,
        timestamp: info.event_timestamp
      }
    }

    info = Object.assign(info, backup);
    
    return info
  },
}

